import 'slick-carousel';
const $ = window.jQuery;
const $window = window.$window || $(window);


const Slideshow = {


  init () {
    var $slideshow = $('.slideshow');
    if (!$slideshow.length)
        return;
    
    
    var slick = createSlick();

    function createSlick() {
  
      $slideshow.each(function(i,el){
        let $slider = $(this).find('.slick');
        if($(this).hasClass('full-bleed')){
          $slider.slick({
            autoplay:true,
            dots:true,
            appendDots:$(this).find('.dots-container'),
            arrows:true,
            appendArrows:$(this).find('.arrows-container'),
            autoplaySpeed: 3000,
            pauseOnHover:false
          });
          // $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
          //   console.log(nextSlide);
          // });
          // $slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
          //   console.log(nextSlide);
          // });
        }else{
          $slider.slick({
            arrows:true,
            appendArrows:$(this).find('.arrows-container'),
          });
        }
      });
      
    }
  
  
    $window.resize(function(){
      
      slick.destroy(true);
      slick = createSlick();
      
      
  
    });
  
  }


};

export default Slideshow;